import React, { useState } from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

const agingBuckets = [
{ label: "0–30 Days", amount: 4200, count: 18, color: "bg-amber-400", textColor: "text-amber-600", bgLight: "bg-amber-50", pct: 34 },
{ label: "31–60 Days", amount: 3800, count: 12, color: "bg-orange-400", textColor: "text-orange-600", bgLight: "bg-orange-50", pct: 31 },
{ label: "61–90 Days", amount: 2600, count: 8, color: "bg-red-400", textColor: "text-red-600", bgLight: "bg-red-50", pct: 21 },
{ label: "90+ Days", amount: 1700, count: 5, color: "bg-red-700", textColor: "text-red-800", bgLight: "bg-red-100", pct: 14 }];


const alerts = [
{ name: "Marcus Johnson", amount: 890, days: 94, avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1ee373157-1772522029108.png", avatarAlt: "Middle-aged African American man with short hair wearing casual gray t-shirt" },
{ name: "Priya Sharma", amount: 650, days: 78, avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19205d2aa-1763296356182.png", avatarAlt: "Young Indian woman with long dark hair smiling in professional setting" },
{ name: "Tom Whitfield", amount: 540, days: 67, avatar: "https://images.unsplash.com/photo-1611608822772-43a28a830759", avatarAlt: "Young Caucasian man with blonde hair wearing blue polo shirt" }];


const reminderCampaigns = [
{ name: "WhatsApp Blast", sent: 145, opened: 112, converted: 38, rate: 34 },
{ name: "Email Reminder", sent: 200, opened: 88, converted: 22, rate: 25 },
{ name: "SMS Alert", sent: 90, opened: 74, converted: 18, rate: 24 }];


export default function AgingReportSidebar() {
  const [activeTab, setActiveTab] = useState("aging");

  return (
    <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-xl shadow-sm flex flex-col overflow-hidden">
      <div className="flex border-b border-[var(--color-border)]">
        {[
        { key: "aging", label: "Aging", icon: "Clock" },
        { key: "alerts", label: "Alerts", icon: "AlertTriangle" },
        { key: "campaigns", label: "Campaigns", icon: "Send" }]?.
        map((tab) =>
        <button
          key={tab?.key}
          onClick={() => setActiveTab(tab?.key)}
          className={`flex-1 flex items-center justify-center gap-1.5 py-3 text-xs font-medium font-[var(--font-caption)] transition-all duration-200 border-b-2 ${activeTab === tab?.key ? "border-[var(--color-primary)] text-[var(--color-primary)] bg-[var(--color-primary)]/5" : "border-transparent text-[var(--color-muted-foreground)] hover:text-[var(--color-foreground)]"}`}>
          
            <Icon name={tab?.icon} size={13} color="currentColor" />
            {tab?.label}
          </button>
        )}
      </div>
      <div className="p-4 flex-1 overflow-y-auto">
        {activeTab === "aging" &&
        <div className="space-y-3">
            <div className="flex items-center justify-between mb-2">
              <h4 className="text-sm font-bold font-[var(--font-heading)] text-[var(--color-foreground)]">Pending by Age</h4>
              <span className="text-xs text-[var(--color-muted-foreground)] font-[var(--font-data)]">$12,300 total</span>
            </div>
            {agingBuckets?.map((bucket) =>
          <div key={bucket?.label} className={`${bucket?.bgLight} rounded-lg p-3`}>
                <div className="flex items-center justify-between mb-2">
                  <span className={`text-xs font-semibold font-[var(--font-caption)] ${bucket?.textColor}`}>{bucket?.label}</span>
                  <span className={`text-xs font-bold font-[var(--font-data)] ${bucket?.textColor}`}>${bucket?.amount?.toLocaleString()}</span>
                </div>
                <div className="flex items-center justify-between mb-1.5">
                  <span className="text-xs text-[var(--color-muted-foreground)] font-[var(--font-caption)]">{bucket?.count} members</span>
                  <span className="text-xs text-[var(--color-muted-foreground)] font-[var(--font-caption)]">{bucket?.pct}%</span>
                </div>
                <div className="w-full bg-white/60 rounded-full h-1.5">
                  <div className={`h-1.5 rounded-full ${bucket?.color} transition-all duration-500`} style={{ width: `${bucket?.pct}%` }} />
                </div>
              </div>
          )}
            <Button variant="outline" size="sm" fullWidth iconName="Download" iconPosition="left" className="mt-2">
              Export Aging Report
            </Button>
          </div>
        }

        {activeTab === "alerts" &&
        <div className="space-y-3">
            <div className="flex items-center justify-between mb-2">
              <h4 className="text-sm font-bold font-[var(--font-heading)] text-[var(--color-foreground)]">High Priority</h4>
              <span className="text-xs bg-red-100 text-red-600 px-2 py-0.5 rounded-full font-[var(--font-caption)] font-medium">5 critical</span>
            </div>
            {alerts?.map((alert) =>
          <div key={alert?.name} className="flex items-center gap-3 p-3 bg-red-50 border border-red-100 rounded-lg">
                <img src={alert?.avatar} alt={alert?.avatarAlt} className="w-9 h-9 rounded-full object-cover flex-shrink-0" onError={(e) => {e.target.src = "/assets/images/no_image.png";}} />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-[var(--color-foreground)] font-[var(--font-caption)] truncate">{alert?.name}</p>
                  <p className="text-xs text-red-600 font-[var(--font-caption)]">${alert?.amount} · {alert?.days} days overdue</p>
                </div>
                <button className="w-8 h-8 flex items-center justify-center rounded-lg bg-[var(--color-primary)] hover:bg-[var(--color-secondary)] transition-colors flex-shrink-0" aria-label={`Send reminder to ${alert?.name}`}>
                  <Icon name="Send" size={14} color="#FFFFFF" />
                </button>
              </div>
          )}
            <Button variant="destructive" size="sm" fullWidth iconName="Zap" iconPosition="left" className="mt-2">
              Bulk Send Reminders
            </Button>
          </div>
        }

        {activeTab === "campaigns" &&
        <div className="space-y-3">
            <div className="flex items-center justify-between mb-2">
              <h4 className="text-sm font-bold font-[var(--font-heading)] text-[var(--color-foreground)]">Reminder Performance</h4>
            </div>
            {reminderCampaigns?.map((c) =>
          <div key={c?.name} className="p-3 bg-[var(--color-muted)] rounded-lg">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm font-semibold text-[var(--color-foreground)] font-[var(--font-caption)]">{c?.name}</span>
                  <span className={`text-xs font-bold px-2 py-0.5 rounded-full font-[var(--font-caption)] ${c?.rate >= 30 ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}>{c?.rate}% CVR</span>
                </div>
                <div className="grid grid-cols-3 gap-2 text-center">
                  {[{ label: "Sent", val: c?.sent }, { label: "Opened", val: c?.opened }, { label: "Converted", val: c?.converted }]?.map((s) =>
              <div key={s?.label}>
                      <p className="text-sm font-bold font-[var(--font-data)] text-[var(--color-foreground)]">{s?.val}</p>
                      <p className="text-xs text-[var(--color-muted-foreground)] font-[var(--font-caption)]">{s?.label}</p>
                    </div>
              )}
                </div>
              </div>
          )}
            <Button variant="default" size="sm" fullWidth iconName="Plus" iconPosition="left" className="mt-2">
              New Campaign
            </Button>
          </div>
        }
      </div>
    </div>);

}